module.exports = __webpack_public_path__ + "img/logo.e0cf2ca6.png";